import { useState, useEffect } from "react";
import axios from "axios";
import CertificationCard from "./CertificationCard";
import CertificationCardLoading from "./CertificationCardLoading";
import "./Certification.css";

function CertificationContainer({ limit }) {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);
  const certApi = process.env.REACT_APP_CERTIFICATION_API_PATH;
  const apiKey  = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    axios
      .get(certApi, { headers: { Authorization: `Api-Key ${apiKey}` } })
      .then((res) => setData(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [certApi, apiKey]);

  const visible = limit ? data.slice(0, limit) : data;
  const skeletonCount = limit ?? 4;

  if (loading) {
    return (
      <div className="cert-grid">
        {Array.from({ length: skeletonCount }, (_, i) => <CertificationCardLoading key={i} />)}
      </div>
    );
  }

  if (!visible.length) {
    return (
      <div className="no-data">
        <p className="body-large" style={{ fontWeight: 600 }}>No certifications found</p>
      </div>
    );
  }

  return (
    <div className="cert-grid">
      {visible.map((item) => (
        <CertificationCard
          key={item.id}
          image={item.image}
          title={item.title}
          credentialUrl={item.credential_url}
        />
      ))}
    </div>
  );
}

export default CertificationContainer;
